export const getUserInitials = (
  user:
    { firstName: string | null; lastName: string | null } | null | undefined,
): string => {
  if (!user) {
    return "";
  }
  const initials = `${user.firstName?.charAt(0) ?? ""}${
    user.lastName?.charAt(0) ?? ""
  }`.toUpperCase();
  return initials;
};

export const buildUserFullName = (user: {
  firstName: string | null;
  lastName: string | null;
}): string => {
  return `${user.firstName ?? ""} ${user.lastName ?? ""}`.trim();
};

export function buildUserDisplayName(
  firstName: string | null,
  lastName: string | null,
  email: string,
): string {
  const name = `${firstName ?? ""} ${lastName ?? ""}`.trim();
  return name || email;
}
